// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-text%2Fsrc%2Fannotations.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------

import { CritiqueAction, IAutoreplaceAnnotation, ICritique, ICritiqueCategoryCountAnnotation, IDefinition, IEmptyDocumentAnnotation, IIdeasPersonalizationSettingsAnnotation, ILanguageCountAnnotation, ILanguageCountAnnotationLocalized, ILanguageDetection, ILanguageDetectionSummaryAnnotation, IMultiTileRangeAnnotation, INeuralRewriteCritique, INeuralRewriteSuggestion, IRangeAnnotation, ISuggestion, ISuggestionsAnnotation, ITextToSpeechAnnotation, IUniqueWordsCountAnnotation, MultiTileRange, Priority, Range } from '../annotations';
import { AnnotationMetaData, ISchemaObject, SchemaObject, SchemaObjectHeader } from '@augloop/types-core';

export class RangeAnnotation implements IRangeAnnotation {
    public readonly range: Range;
    public readonly invalidationRange?: Range;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IRangeAnnotation) {
        SchemaObject.assign(RangeAnnotation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_RangeAnnotation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: RangeAnnotation.getTypeName(), B_: RangeAnnotation.getBaseTypes() };
    /**
     * Checks if passed schema object is of RangeAnnotation type or its inheritor and implements {@link IRangeAnnotation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IRangeAnnotation {
        return SchemaObject.matchesTypesFor(schemaObject, [RangeAnnotation.getTypeName()]);
    }
}

export class MultiTileRangeAnnotation implements IMultiTileRangeAnnotation {
    public readonly range: MultiTileRange;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IMultiTileRangeAnnotation) {
        SchemaObject.assign(MultiTileRangeAnnotation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_MultiTileRangeAnnotation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: MultiTileRangeAnnotation.getTypeName(), B_: MultiTileRangeAnnotation.getBaseTypes() };
    /**
     * Checks if passed schema object is of MultiTileRangeAnnotation type or its inheritor and implements {@link IMultiTileRangeAnnotation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IMultiTileRangeAnnotation {
        return SchemaObject.matchesTypesFor(schemaObject, [MultiTileRangeAnnotation.getTypeName()]);
    }
}

export class LanguageDetectionSummaryAnnotation implements ILanguageDetectionSummaryAnnotation {
    public totalCharacterCount: number;
    public languageAnnotations: ILanguageDetection[];
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ILanguageDetectionSummaryAnnotation) {
        SchemaObject.assign(LanguageDetectionSummaryAnnotation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_LanguageDetectionSummaryAnnotation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: LanguageDetectionSummaryAnnotation.getTypeName(), B_: LanguageDetectionSummaryAnnotation.getBaseTypes() };
    /**
     * Checks if passed schema object is of LanguageDetectionSummaryAnnotation type or its inheritor and implements {@link ILanguageDetectionSummaryAnnotation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is ILanguageDetectionSummaryAnnotation {
        return SchemaObject.matchesTypesFor(schemaObject, [LanguageDetectionSummaryAnnotation.getTypeName()]);
    }
}

export class LanguageCountAnnotation implements ILanguageCountAnnotation {
    public language: string;
    public characterCount: number;
    public percentage: number;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ILanguageCountAnnotation) {
        SchemaObject.assign(LanguageCountAnnotation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_LanguageCountAnnotation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: LanguageCountAnnotation.getTypeName(), B_: LanguageCountAnnotation.getBaseTypes() };
    /**
     * Checks if passed schema object is of LanguageCountAnnotation type or its inheritor and implements {@link ILanguageCountAnnotation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is ILanguageCountAnnotation {
        return SchemaObject.matchesTypesFor(schemaObject, [LanguageCountAnnotation.getTypeName()]);
    }
}

export class LanguageCountAnnotationLocalized implements ILanguageCountAnnotationLocalized {
    public cultureInfo: { [culture: string]: string };
    public languageLocalized: string;
    public language: string;
    public characterCount: number;
    public percentage: number;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ILanguageCountAnnotationLocalized) {
        SchemaObject.assign(LanguageCountAnnotationLocalized, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_LanguageCountAnnotationLocalized';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Text_LanguageCountAnnotation', 'AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: LanguageCountAnnotationLocalized.getTypeName(), B_: LanguageCountAnnotationLocalized.getBaseTypes() };
    /**
     * Checks if passed schema object is of LanguageCountAnnotationLocalized type or its inheritor and implements {@link ILanguageCountAnnotationLocalized}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is ILanguageCountAnnotationLocalized {
        return SchemaObject.matchesTypesFor(schemaObject, [LanguageCountAnnotationLocalized.getTypeName()]);
    }
}

export class Definition implements IDefinition {
    public readonly name: string;
    public readonly text: string;
    public readonly range: Range;
    public readonly invalidationRange?: Range;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IDefinition) {
        SchemaObject.assign(Definition, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_Definition';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Text_RangeAnnotation', 'AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: Definition.getTypeName(), B_: Definition.getBaseTypes() };
    /**
     * Checks if passed schema object is of Definition type or its inheritor and implements {@link IDefinition}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IDefinition {
        return SchemaObject.matchesTypesFor(schemaObject, [Definition.getTypeName()]);
    }
}

export class SuggestionsAnnotation implements ISuggestionsAnnotation {
    public readonly suggestions: ISuggestion[];
    public readonly range: Range;
    public readonly invalidationRange?: Range;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ISuggestionsAnnotation) {
        SchemaObject.assign(SuggestionsAnnotation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_SuggestionsAnnotation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Text_RangeAnnotation', 'AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: SuggestionsAnnotation.getTypeName(), B_: SuggestionsAnnotation.getBaseTypes() };
    /**
     * Checks if passed schema object is of SuggestionsAnnotation type or its inheritor and implements {@link ISuggestionsAnnotation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is ISuggestionsAnnotation {
        return SchemaObject.matchesTypesFor(schemaObject, [SuggestionsAnnotation.getTypeName()]);
    }
}

export class Critique implements ICritique {
    public readonly priority: Priority;
    public readonly context: string;
    public readonly startInContext: number;
    public readonly categoryName: string;
    public readonly language?: string;
    public readonly explanationTitle?: string;
    public readonly explanationBody?: string;
    public readonly explanationLabel?: string;
    public readonly bucketId?: number;
    public readonly typeId?: string;
    public readonly critiqueActions?: CritiqueAction;
    public readonly critiqueMetadata?: { [name: string]: string };
    public readonly suggestions: ISuggestion[];
    public readonly range: Range;
    public readonly invalidationRange?: Range;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ICritique) {
        SchemaObject.assign(Critique, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_Critique';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Text_SuggestionsAnnotation', 'AugLoop_Text_RangeAnnotation', 'AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: Critique.getTypeName(), B_: Critique.getBaseTypes() };
    /**
     * Checks if passed schema object is of Critique type or its inheritor and implements {@link ICritique}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is ICritique {
        return SchemaObject.matchesTypesFor(schemaObject, [Critique.getTypeName()]);
    }
}

export class NeuralRewriteCritique implements INeuralRewriteCritique {
    public readonly trackId?: string;
    public readonly neuralRewriteSuggestions: INeuralRewriteSuggestion[];
    public readonly editorResponseStatusCode: number;
    public readonly priority: Priority;
    public readonly context: string;
    public readonly startInContext: number;
    public readonly categoryName: string;
    public readonly language?: string;
    public readonly explanationTitle?: string;
    public readonly explanationBody?: string;
    public readonly explanationLabel?: string;
    public readonly bucketId?: number;
    public readonly typeId?: string;
    public readonly critiqueActions?: CritiqueAction;
    public readonly critiqueMetadata?: { [name: string]: string };
    public readonly suggestions: ISuggestion[];
    public readonly range: Range;
    public readonly invalidationRange?: Range;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: INeuralRewriteCritique) {
        SchemaObject.assign(NeuralRewriteCritique, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_NeuralRewriteCritique';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Text_Critique', 'AugLoop_Text_SuggestionsAnnotation', 'AugLoop_Text_RangeAnnotation', 'AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: NeuralRewriteCritique.getTypeName(), B_: NeuralRewriteCritique.getBaseTypes() };
    /**
     * Checks if passed schema object is of NeuralRewriteCritique type or its inheritor and implements {@link INeuralRewriteCritique}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is INeuralRewriteCritique {
        return SchemaObject.matchesTypesFor(schemaObject, [NeuralRewriteCritique.getTypeName()]);
    }
}

export class CritiqueCategoryCountAnnotation implements ICritiqueCategoryCountAnnotation {
    public categoryName: string;
    public count: number;
    public countsByTypeId?: { [typeId: string]: number };
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ICritiqueCategoryCountAnnotation) {
        SchemaObject.assign(CritiqueCategoryCountAnnotation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_CritiqueCategoryCountAnnotation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: CritiqueCategoryCountAnnotation.getTypeName(), B_: CritiqueCategoryCountAnnotation.getBaseTypes() };
    /**
     * Checks if passed schema object is of CritiqueCategoryCountAnnotation type or its inheritor and implements {@link ICritiqueCategoryCountAnnotation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is ICritiqueCategoryCountAnnotation {
        return SchemaObject.matchesTypesFor(schemaObject, [CritiqueCategoryCountAnnotation.getTypeName()]);
    }
}

export class UniqueWordsCountAnnotation implements IUniqueWordsCountAnnotation {
    public count: number;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IUniqueWordsCountAnnotation) {
        SchemaObject.assign(UniqueWordsCountAnnotation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_UniqueWordsCountAnnotation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: UniqueWordsCountAnnotation.getTypeName(), B_: UniqueWordsCountAnnotation.getBaseTypes() };
    /**
     * Checks if passed schema object is of UniqueWordsCountAnnotation type or its inheritor and implements {@link IUniqueWordsCountAnnotation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IUniqueWordsCountAnnotation {
        return SchemaObject.matchesTypesFor(schemaObject, [UniqueWordsCountAnnotation.getTypeName()]);
    }
}

export class EmptyDocumentAnnotation implements IEmptyDocumentAnnotation {
    public isEmpty: boolean;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IEmptyDocumentAnnotation) {
        SchemaObject.assign(EmptyDocumentAnnotation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_EmptyDocumentAnnotation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: EmptyDocumentAnnotation.getTypeName(), B_: EmptyDocumentAnnotation.getBaseTypes() };
    /**
     * Checks if passed schema object is of EmptyDocumentAnnotation type or its inheritor and implements {@link IEmptyDocumentAnnotation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IEmptyDocumentAnnotation {
        return SchemaObject.matchesTypesFor(schemaObject, [EmptyDocumentAnnotation.getTypeName()]);
    }
}

export class IdeasPersonalizationSettingsAnnotation implements IIdeasPersonalizationSettingsAnnotation {
    public isIdeasPaneTriggerLaunchSuppressed: boolean;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IIdeasPersonalizationSettingsAnnotation) {
        SchemaObject.assign(IdeasPersonalizationSettingsAnnotation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_IdeasPersonalizationSettingsAnnotation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: IdeasPersonalizationSettingsAnnotation.getTypeName(), B_: IdeasPersonalizationSettingsAnnotation.getBaseTypes() };
    /**
     * Checks if passed schema object is of IdeasPersonalizationSettingsAnnotation type or its inheritor and implements {@link IIdeasPersonalizationSettingsAnnotation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IIdeasPersonalizationSettingsAnnotation {
        return SchemaObject.matchesTypesFor(schemaObject, [IdeasPersonalizationSettingsAnnotation.getTypeName()]);
    }
}

export class TextToSpeechAnnotation implements ITextToSpeechAnnotation {
    public readonly audioData: string[];
    public readonly isValidTTS?: boolean;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ITextToSpeechAnnotation) {
        SchemaObject.assign(TextToSpeechAnnotation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_TextToSpeechAnnotation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: TextToSpeechAnnotation.getTypeName(), B_: TextToSpeechAnnotation.getBaseTypes() };
    /**
     * Checks if passed schema object is of TextToSpeechAnnotation type or its inheritor and implements {@link ITextToSpeechAnnotation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is ITextToSpeechAnnotation {
        return SchemaObject.matchesTypesFor(schemaObject, [TextToSpeechAnnotation.getTypeName()]);
    }
}

export class AutoreplaceAnnotation implements IAutoreplaceAnnotation {
    public readonly priority: Priority;
    public readonly context: string;
    public readonly startInContext: number;
    public readonly categoryName: string;
    public readonly language?: string;
    public readonly explanationTitle?: string;
    public readonly explanationBody?: string;
    public readonly explanationLabel?: string;
    public readonly bucketId?: number;
    public readonly typeId?: string;
    public readonly critiqueActions?: CritiqueAction;
    public readonly critiqueMetadata?: { [name: string]: string };
    public readonly suggestions: ISuggestion[];
    public readonly range: Range;
    public readonly invalidationRange?: Range;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IAutoreplaceAnnotation) {
        SchemaObject.assign(AutoreplaceAnnotation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_AutoreplaceAnnotation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Text_Critique', 'AugLoop_Text_SuggestionsAnnotation', 'AugLoop_Text_RangeAnnotation', 'AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: AutoreplaceAnnotation.getTypeName(), B_: AutoreplaceAnnotation.getBaseTypes() };
    /**
     * Checks if passed schema object is of AutoreplaceAnnotation type or its inheritor and implements {@link IAutoreplaceAnnotation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IAutoreplaceAnnotation {
        return SchemaObject.matchesTypesFor(schemaObject, [AutoreplaceAnnotation.getTypeName()]);
    }
}

